"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__doc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc5095ae-1e67-4513-b433-590cc7493523",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-doc-hi"), /*#__PURE__*/React.createElement("g", {
    id: "52003c05-1843-48b1-a85a-b3e01156ca55",
    "data-name": "document-doc-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "337436d6-4067-4d43-972d-a7cf181e3dc0",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb735a59-7aa5-4947-a436-b9054b9b8b2b",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a8543e4-2a21-4a69-8011-6dc23a780bc7",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2414589a-c360-4712-95fb-735dcb849c0a",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8d84f2ac-16ac-48cb-9ccb-d21aefab0fbd",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "65356fe5-b20a-46eb-a63d-8978aa4b2727",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16cb24ed-475c-45a0-8f98-dbeabe771089",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5e362c2c-07da-445a-b1d9-1c3ddb2bd63e",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0911dedb-471a-4629-9855-bba70783f7af",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "056d2327-77ea-45fc-beef-a7518abe781e",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4001f320-53e5-40ed-a4d1-d9296919b6dc",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "33a8396b-01fc-4203-a330-717a23b35ead",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6c2e93f8-6245-4e2a-acbe-19225d4c675b",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "26230ec5-150c-4acc-820a-956285956066",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "720e4a59-3388-43c5-b4f1-7b36a3232da8",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c4b32019-e34e-4238-8ab1-011d6fe14ba3",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4d54ecd0-e5ad-4103-a581-175db09ac51a",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "336c8f3f-2896-4e48-9416-d669c364181e",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d669e209-c9dc-42a2-b29d-51c434506d3f",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c6bebc96-7660-4dae-abee-cd6c732d312d",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8709b18f-b023-4a41-bc76-c2a03578c494",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5ec7c485-8fe0-40cd-badb-10b036597a52",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8d219ad-a90c-4176-9a4a-34ec70ff123c",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92a83c6a-5677-42b8-ba56-d06d8ef1d8c9",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1d857dfa-25fc-4d7d-889e-790e014987c3",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18cedb9a-ad61-430e-9148-6063c9491805",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06280859-5064-4d43-97ae-93dac6238ae0",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "99aab072-8bea-4962-9cbc-d664ea782d28",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#dc5095ae-1e67-4513-b433-590cc7493523)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.17,125.58a2.73,2.73,0,0,1-2.3-1,3.45,3.45,0,0,1-.77-2.17,3.52,3.52,0,0,1,.77-2.21,2.73,2.73,0,0,1,2.3-1,2.67,2.67,0,0,1,2.28,1,3.59,3.59,0,0,1,.75,2.21,3.52,3.52,0,0,1-.75,2.17A2.67,2.67,0,0,1,51.17,125.58Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,125.1V95.87h8.24a26.24,26.24,0,0,1,3.51.26,13.35,13.35,0,0,1,3.68,1.05,11.08,11.08,0,0,1,4.32,3.7,14.19,14.19,0,0,1,2.21,4.89,20.69,20.69,0,0,1,.57,4.56,18,18,0,0,1-1,6,12.82,12.82,0,0,1-2.67,4.62,12.16,12.16,0,0,1-3.48,2.67,15.64,15.64,0,0,1-6.93,1.49Zm5.61-5.26h2.28a10.62,10.62,0,0,0,5-1.1,6.7,6.7,0,0,0,2.94-3.35,12.09,12.09,0,0,0,1-4.8,12.68,12.68,0,0,0-.88-4.71,7.2,7.2,0,0,0-2.72-3.44,7,7,0,0,0-2.39-1,12.57,12.57,0,0,0-2.83-.33H64.58Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,125.72a11.25,11.25,0,0,1-5.59-1.34,12.53,12.53,0,0,1-4-3.48A15.08,15.08,0,0,1,86,116a19.88,19.88,0,0,1,0-11.09A15.09,15.09,0,0,1,88.36,100a12.32,12.32,0,0,1,4-3.46,12.4,12.4,0,0,1,13.19,1.31,13.26,13.26,0,0,1,4.21,6.22,21.76,21.76,0,0,1,1.12,6.36,19.44,19.44,0,0,1-.81,5.54,15.44,15.44,0,0,1-2.41,4.89,12.4,12.4,0,0,1-4,3.48A11.6,11.6,0,0,1,97.93,125.72Zm0-5.22a5.89,5.89,0,0,0,4.21-1.67,8.49,8.49,0,0,0,2.39-4.05,17,17,0,0,0,.64-4.32,14,14,0,0,0-1-5.39,7.35,7.35,0,0,0-2.74-3.57,6.45,6.45,0,0,0-3.46-1.07,5.64,5.64,0,0,0-3,.83,7.1,7.1,0,0,0-2.24,2.24,10.88,10.88,0,0,0-1.36,3.22,15.49,15.49,0,0,0,0,7.5,10.86,10.86,0,0,0,1.36,3.22,7.08,7.08,0,0,0,2.24,2.24A5.64,5.64,0,0,0,97.93,120.5Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.21,125.72a13,13,0,0,1-5.06-1,10.88,10.88,0,0,1-4-2.87,13.21,13.21,0,0,1-2.61-4.73,21.19,21.19,0,0,1-.92-6.55,19.45,19.45,0,0,1,1.07-6.82A14.44,14.44,0,0,1,118.53,99a11.1,11.1,0,0,1,4-2.83,12.15,12.15,0,0,1,4.62-.92,13,13,0,0,1,4.78.81,8.36,8.36,0,0,1,3.18,2,14.93,14.93,0,0,1,1.78,2.32l-4.12,3.46a11.59,11.59,0,0,0-.64-1,5.71,5.71,0,0,0-1.1-1.14,6.67,6.67,0,0,0-1.62-.94,5.57,5.57,0,0,0-2.17-.39,6,6,0,0,0-4.87,2.43,9.32,9.32,0,0,0-1.51,3.16,16.73,16.73,0,0,0-.55,4.58q0,4.78,2.06,7.34a6.67,6.67,0,0,0,5.48,2.56,9.93,9.93,0,0,0,4.3-.85,9.54,9.54,0,0,0,2.59-1.64l1.8,4.87a7.43,7.43,0,0,1-2,1.27,16.24,16.24,0,0,1-3.31,1.12A17.61,17.61,0,0,1,127.21,125.72Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  })))))))))))))))))))))))))))))));
}

var _default = ic_document__doc;
exports.default = _default;